export const BASE_URL = "https://v4pre.h5sys.cn/api/11382358"
export const TIMEOUT = 10000